import { computed, shallowRef } from 'vue'

import { useAdDisabledStore } from '@/store/ad-disabled-store'

type AdDisabledReason = 'ad-free-mode' | 'ad-disabled'

export function useDisabledAdFiller() {
    const adStore = useAdDisabledStore()

    const resolveDisabledAdFiller = shallowRef<(options: { reason: AdDisabledReason }) => void>()
    const reason = computed<AdDisabledReason>(() => (adStore.isAdFreeActive ? 'ad-free-mode' : 'ad-disabled'))

    function stopDisabledAdFiller() {
        resolveDisabledAdFiller.value?.({ reason: reason.value })
        resolveDisabledAdFiller.value = undefined
    }

    function adDisabledHandler(adAction?: string): Promise<{ reason: AdDisabledReason }> | null {
        if (!adStore.isAdDisabled) {
            return null
        }

        if (adAction === 'showRewarded') {
            return new Promise((resolve) => {
                resolveDisabledAdFiller.value = resolve
            })
        }

        return Promise.resolve({ reason: reason.value })
    }

    const isDisabledAdFillerVisible = computed(() => !!resolveDisabledAdFiller.value)

    return { stopDisabledAdFiller, adDisabledHandler, isDisabledAdFillerVisible }
}
